// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__9_INL","productName":"Table_productName__2J5j6"};